import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const MusicPage = lazy(() => import('@/features/music/pages/MusicPage'));

export const musicRoutes = (
  <>
    <Route path="/music" element={<LazyRoute fallbackMessage="Loading music..."><MusicPage /></LazyRoute>} />
  </>
);
